// extracted by mini-css-extract-plugin
module.exports = {"bg_l5":"#8f8f8f","monoStack":"\"Roboto Mono\",monospace","inputErrorWrap":"ractfFormHoc_inputErrorWrap__21hNW","inputError":"ractfFormHoc_inputError__2RD1H"};